(function () {
  let jQueryBopis, $location, backdrop, currentProduct, nearestStoreWithInventory, queryString, stores, storesWithInventory, variantId, productSku, isCurrentLocationAccessed, pageUrl;

  let baseUrl = "https://aviator-oms.hotwax.io";

  let loadScript = function(url, callback) {

    let script = document.createElement("script");
    script.type = "text/javascript";

    if (script.readyState) { 
      script.onreadystatechange = function() {
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function() {
        callback();
      };
    }
  
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  };

  if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn['jquery']) < 1.7)) {
    loadScript('//ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js', function(){
      jQueryBopis = jQuery.noConflict(true);
      jQueryBopis(document).ready(function() {
        initialiseBopis();
      });
    });
  } else {
    jQueryBopis = jQuery;
    jQuery(document).ready(function() {
      initialiseBopis();
    });
  }

  /*
  Fetch the current location of the user using browser's navigator object

  @return {location}
  */
  function getCurrentLocation () {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    })
  }

  // function will open the modal for the bopis
  function openBopisModal (event) {
    // to stop event bubbling when clicking on the Check Stores button
    event.preventDefault();
    event.stopImmediatePropagation();

    backdrop = jQueryBopis('<div id="hc-backdrop"></div>');
    jQueryBopis("body").append(backdrop);
    // add overflow style to disable background scroll when modal is opened
    jQueryBopis("body").css("overflow", "hidden");
    jQueryBopis(".hc-bopis-modal")[0].style.display = "block";

    // If having a queryString available then prefill the input with the same value
    if(queryString) {
      jQueryBopis("#hc-bopis-store-pin").val(queryString)
      handleAddToCartEvent();
    }

    jQueryBopis("#hc-bopis-store-pin").focus();
  }

  function closeBopisModal () {
    jQueryBopis(".hc-bopis-modal")[0].style.display = "none";
    jQueryBopis("body").css("overflow", "scroll");
    backdrop.remove();
  }

  // function will display the store search input on PDP
  async function openStoreAvailability (event) {
    let errorMessage = "";

    // to stop event bubbling when clicking on the Check Stores button
    event.preventDefault();
    event.stopImmediatePropagation();

    // Fetch user location, as soon as the user clicks the check button on PDP
    try {
      const hcUserLocation = JSON.parse(getFromStorage("HC_USER_LOCATION"))

      if(hcUserLocation && hcUserLocation.location) {
        $location = hcUserLocation.location
      } else {
        const userLocation = await getCurrentLocation()
        $location = userLocation.coords
      }
    } catch(err) {
      errorMessage = "Unable to access user location"
      console.error('Error getting location', err)
    }
    let zipCode = "";
    if ($location) {
      isCurrentLocationAccessed = true
      setToStorage("HC_USER_LOCATION", JSON.stringify({ location: $location, isCurrentLocationAccessed}))
      zipCode = await getZipCodeForLatlon(`${$location.latitude}, ${$location.longitude}`);
      queryString = zipCode;
      setToStorage("HC_SEARCHED_CODE", queryString)
      jQueryBopis("#hc-store-availability-pin").val(zipCode)
      searchStores(event, $location, '');
    }

    if(!zipCode) {
      jQueryBopis(".hc-store-availability-wrapper")[0].style.display = "block";
      jQueryBopis("#hc-store-availability")[0].style.display = "none";
      searchStores(event, $location, $location ? "We don't recognize your zipcode, please try a different zipcode" : "Unable to access user location");
    }

    jQueryBopis("#hc-store-availability-pin").focus();
  }

  function closeStoreAvailability () {
    jQueryBopis(".hc-store-availability-wrapper")[0].style.display = "none";
    jQueryBopis("#hc-store-availability")[0].style.display = "block";
  }

  // function will display the store search input on PDP
  function openStoreAvailabilityForm (event) {
    // to stop event bubbling when clicking on the Check Stores button
    event.preventDefault();
    event.stopImmediatePropagation();

    jQueryBopis('.hc-nearest-store-information').empty();
    jQueryBopis("#hc-store-availability-form")[0].style.display = "flex";
    jQueryBopis("#hc-store-availability-pin")[0].focus();
  }

  function closeStoreAvailabilityForm () {
    jQueryBopis("#hc-store-availability-form")[0].style.display = "none";
  }

  async function getCurrentProduct() {
    await jQueryBopis.getJSON(`${window.location.pathname}.js`, function(product) {
      currentProduct = product;
    });
  }

  function getFromStorage(key) {
    return localStorage.getItem(key)
  }

  function setToStorage(key, value) {
    localStorage.setItem(key, value)
  }

  function getProductOptions() {
    let options = {}
    const currentVariant = currentProduct.variants.find(variant => variant.id == variantId)
    if(!currentVariant) {
      return {};
    }
    const variantOptions = currentVariant.options

    variantOptions.map(option => {
      const productOption = currentProduct.options.find(op => op.values.includes(option))
      if(productOption) {
        options[productOption.name] = option
      }
    })
    return options;
  }

  async function initialiseBopis () {
    if (location.pathname.includes('/products/')) {      
      await getCurrentProduct(); // fetch the information for the current product

      jQueryBopis(".hc-store-information").remove();
      jQueryBopis("#hc-store-availability-form").remove();
      jQueryBopis(".hc-nearest-store-information").remove();
      jQueryBopis(".hc-no-store-found").remove();
      jQueryBopis(".hc-bopis-modal").remove();
      jQueryBopis(".hc-store-availability-wrapper").hide();
      const storeAvailabilityButton = jQueryBopis("#hc-store-availability");

      // TODO: need to check more reliable way to get variantId
      let [currentPageUrl, _] = location.href.split("variant=")
      if(!variantId) {
        const variantSelects = document.querySelector('variant-selects');
        if (variantSelects && variantSelects.currentVariant) {
          variantId = variantSelects.currentVariant.id;
        }
      }

      if(pageUrl !== currentPageUrl) {
        isCurrentLocationAccessed = false;
        setToStorage("HC_USER_LOCATION", JSON.stringify({ location: $location, isCurrentLocationAccessed}))
        pageUrl = currentPageUrl;
      }

      const variantInformation = jQuery(hc_metaData)[0]
      // Do not enable BOPIS when the current product is not available
      if(!variantInformation[variantId] || variantInformation[variantId].inventory <= 0) {
        storeAvailabilityButton.hide();
        return;
      }

      storeAvailabilityButton.show();
      productSku = variantInformation[variantId].sku;

      let $storeSearchInput = jQueryBopis(`
        <div id="hc-store-availability-form" class="hc-input-wrapper">
          <input id="hc-store-availability-pin" class="hc-bopis-store-pin hc-input" type="text" name="pin" aria-label="Enter zipcode" placeholder="Enter zipcode" style="width: 100%; border:0px;">
          <i class="fa fa-regular fa-border hc-fa-border fa-crosshairs hc-icon hc-location-icon hc-location-icon-pdp" tabindex="0"></i>
        </div>
        <div class="hc-nearest-store-information"></div>
        <p class="hc-no-store-found"></p>
      `);

      let $pickUpModal = jQueryBopis(`<div id="hc-bopis-modal" class="hc-bopis-modal">
        <div class="hc-modal-content">
          <div class="hc-modal-header">
              <span class="hc-close"></span>
              <div class="hc-product-wrapper">
                <img class="hc-product-image" src="${currentProduct.featured_image}" alt="${currentProduct.title}" />
                <div class="hc-product-info">
                  <span class="hc-modal-title">Pick up today</span>
                  <p class="hc-product-title">${currentProduct.title}</p>
                  <div class="hc-product-metadata"></div>
                </div>
                <img class="hc-brand-logo" src="//www.aviatornation.com/cdn/shop/files/AV_Logo_MAIN_23_4_410x.png?v=1732312797" class="ls-is-cached lazyloaded" alt="Aviator Nation">
              </div>
          </div>
          <form id="hc-bopis-form">
              <div class="hc-input-wrapper" style="border: 0px; border-bottom: 1px solid;">
                <input id="hc-bopis-store-pin" class="hc-input" name="pin" type="text" aria-label="Enter zipcode" placeholder="Enter zipcode" style="width: 100%; border:0px;">
                <i class="fa fa-regular fa-border hc-fa-border fa-crosshairs hc-icon hc-location-icon hc-location-icon-modal" tabindex="0"></i>
              </div>
              <button type="submit" class="button outline hc-bopis-pick-up-button"><span>Find Stores</span></button>
          </form>
          <div class="hc-store-information"></div>
          <p class="hc-store-not-found"></p>
        </div>
      </div>`);

      jQueryBopis("body").append($pickUpModal);

      Object.entries(getProductOptions()).map(([key, value]) => {
        jQueryBopis(".hc-product-metadata").append(`<p><strong>${key}</strong>: ${value}</p>`);
      })
    
      jQueryBopis(".hc-store-availability-wrapper").append($storeSearchInput);

      storeAvailabilityButton.on('click', await openStoreAvailability);
      jQueryBopis(".hc-location-icon-pdp").on("click", async function () {
        event.preventDefault();
        event.stopImmediatePropagation();
        try {
          const hcUserLocation = JSON.parse(getFromStorage("HC_USER_LOCATION"))

          if(hcUserLocation && hcUserLocation.location) {
            $location = hcUserLocation.location
          } else {
            const userLocation = await getCurrentLocation()
            $location = userLocation.coords
          }
        } catch(err) {
          console.error('Error getting location', err)
          searchStores(event, $location, "Unable to access user location");
        }
        let zipCode = "";
        if ($location) {
          isCurrentLocationAccessed = true
          setToStorage("HC_USER_LOCATION", JSON.stringify({ location: $location, isCurrentLocationAccessed}))
          zipCode = await getZipCodeForLatlon(`${$location.latitude}, ${$location.longitude}`);
          queryString = zipCode;
          setToStorage("HC_SEARCHED_CODE", queryString)
          jQueryBopis("#hc-store-availability-pin").val(zipCode)
        }
        if (zipCode) {
          searchStores();
          setToStorage("HC_SEARCHED_CODE", JSON.stringify(zipCode))
        } else {
          searchStores(event, $location, $location ? "We don't recognize your zipcode, please try a different zipcode" : "Unable to access user location");
        }
      })

      jQueryBopis(".hc-location-icon-modal").on("click", async function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        try {
          const hcUserLocation = JSON.parse(getFromStorage("HC_USER_LOCATION"))

          if(hcUserLocation && hcUserLocation.location) {
            $location = hcUserLocation.location
          } else {
            const userLocation = await getCurrentLocation()
            $location = userLocation.coords
          }
        } catch(err) {
          console.error('Error getting location', err)
        }
        let zipCode = "";
        if ($location) {
          isCurrentLocationAccessed = true
          setToStorage("HC_USER_LOCATION", JSON.stringify({ location: $location, isCurrentLocationAccessed}))
          zipCode = await getZipCodeForLatlon(`${$location.latitude}, ${$location.longitude}`);
        }
        if(zipCode) {
          queryString = zipCode;
          jQueryBopis("#hc-bopis-store-pin").val(zipCode)
          handleAddToCartEvent(event, $location);
        } else {
          queryString = "";
          jQueryBopis("#hc-bopis-store-pin").val("")
          displayStoreInformation([], $location ? "We don't recognize your zipcode, please try a different zipcode" : "Unable to access user location");
        }
        setToStorage("HC_SEARCHED_CODE", queryString)
      })

      jQueryBopis(".hc-close").on('click', closeBopisModal);
      jQueryBopis(".hc-bopis-pick-up-button").on('click', handleAddToCartEvent);
      jQueryBopis('#hc-store-availability-pin').keypress(function (e) {
        var key = e.which;
        if(key == 13) {
          searchStores();
          const zipCode = jQueryBopis('#hc-store-availability-pin').val()
          setToStorage("HC_SEARCHED_CODE", JSON.stringify(zipCode))
        }
      });
      jQueryBopis("body").on('click', function(event) {
        if (event.target == jQueryBopis("#hc-bopis-modal")[0]) {
          closeBopisModal();
        }
      })

      const userLocation = JSON.parse(getFromStorage('HC_USER_LOCATION'))
      const userSearchedCode = JSON.parse(getFromStorage('HC_SEARCHED_CODE'))
      if(userLocation.isCurrentLocationAccessed) {
        storeAvailabilityButton.click();
      } else if(userSearchedCode) {
        storeAvailabilityButton.hide();
        jQueryBopis("#hc-store-availability-pin").val(userSearchedCode)
        searchStores();
      }
    }
  }

  async function getStoreInformation (queryString, location) {
    let latLon = location
    if(!latLon) {
      latLon = await getLatLonForZipCode(queryString);
      if(!latLon) {
        console.error('latlon not found');              
        return { error: "We don't recognize your zipcode, please try a different zipcode" };
      }
    }

    const payload = {
      viewSize: 100
    }

    if (latLon) {
      payload["point"] = latLon
      payload["distance"] = 30
    } else if ($location) {
      payload["point"] = `${$location.latitude}, ${$location.longitude}`
      payload["distance"] = 30
    } else {
      payload["keyword"] = queryString
    }

    // applied a condition that if we have location permission then searching the stores for the current location
    // if we have both location and pin, then using the pin to search for stores
    // if we doesn't have location permission and pin, then will fetch all the available stores
    return new Promise(function(resolve, reject) {
      jQueryBopis.ajax({
        type: 'POST',
        url: `${baseUrl}/api/storeLookup`,
        crossDomain: true,
        data: payload,
        success: function (res) {
          resolve(res)
        },
        error: function (err, textStatus) {
          reject(textStatus);
        }
      })
    })
  }

  async function checkInventory(payload) {
    const params = {
      filters: {
        sku: payload.sku,
        facilityId: payload.facilityIds,
        facilityId_op: 'in'
      },
      viewSize: payload.facilityIds.length
    }

    let resp;

      // added try catch to handle network related errors
    try {
      resp = await new Promise(function(resolve, reject) {
        jQueryBopis.ajax({
          type: 'POST',
          url: `${baseUrl}/api/checkInventory`,
          crossDomain: true,
          data: JSON.stringify(params),
          dataType: 'JSON',
          headers: {
            'Content-Type': 'application/json'
          },
          success: function (data) {
            resolve(data);
          },
          error: function (xhr, textStatus, exception) {
            reject(textStatus)
          }
        })
      })
    } catch (err) {
      resp = err;
    }
    return resp;
  }

  /*
  Fetch the latlon information for a zip, if present.

  @param {number} zipCode for which the latlon needs to be fetched
  @return {number} location for the zipcode in the format <lat,lon>
  */
  async function getLatLonForZipCode(zipCode) {
    let latLon = ''

      // Need to check for leading zero, as we have indexing specific issue when the zip starts with 0
    const query = zipCode.startsWith('0') ? `${zipCode} OR ${zipCode.substring(1)}` : zipCode;

    const payload = {
      "json": {
        "params": {
          "q": `postcode:${query}`
        }
      }
    }

      try {
        latLon = await new Promise(function(resolve, reject) {
          jQueryBopis.ajax({
            type: 'POST',
            url: `${baseUrl}/api/postcodeLookup`,
            data: JSON.stringify(payload),
            headers: {
              'Content-Type': 'application/json'
            },
            crossDomain: true,
            success: function (data) {
              // added error check in here as in error case, api still returns 200 but has an error in response
              if(data.error) {
                reject('')
              } else {
                // assuming that when fetching the latlon for a zipcode there will only be one associated
                // latlon for a zipcode and hence accessing the 0th index of docs
                resolve(data.response.numFound > 0 ? data.response.docs[0].location : '');
              }
            },
            error: function (xhr, textStatus, exception) {
              reject(textStatus)
            }
          })
        })
      } catch (err) {
        latLon = ''
      }
      return latLon;
  }

  /*
  Fetch the zipCode information for the latlon, and does not honor proximity.

  @param {string} pt lat,lon for which the zipCode needs to be fetched
  @return {string} code for the passed latlon if found, otherwise empty
  */
  async function getZipCodeForLatlon(pt) {
    let zipCode = ''
    const payload = {
      "json" : {
        "params": {
          "q": "*:*",
          "fq": "{!geofilt sfield=location}",
          "pt": pt,
          "d": 50 // passed d as 50, as we want zipCode in 50 radius
        }
      }
    }

    try {
      zipCode = await new Promise(function(resolve, reject) {
        jQueryBopis.ajax({
          type: 'POST',
          url: `${baseUrl}/api/postcodeLookup`,
          data: JSON.stringify(payload),
          headers: {
            'Content-Type': 'application/json'
          },
          crossDomain: true,
          success: function (data) {
            if(data.error) {
              reject('')
            } else {
              // assuming that when fetching the zipcode for a latlon there will be multiple
              // zipcodes as we are passing d as 50 and hence accessing the 0th index of docs
              resolve(data.response.numFound > 0 ? data.response.docs[0].postcode : '');
            }
          },
          error: function (xhr, textStatus, exception) {
            reject(textStatus)
          }
        })
      })
    } catch (err) {
      zipCode = ''
    }
    return zipCode;
  }


  async function searchStores(event, location, errorMessage) {
    let eventTarget;
    if (event) {
      eventTarget = jQueryBopis(event.target);
      // to stop event bubbling when clicking on the Check Stores button
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    queryString = jQueryBopis("#hc-store-availability-pin").val();

    let storeInformation = "", result = "";
    if(queryString && !errorMessage) {
      storeInformation = await getStoreInformation(queryString, location ? `${$location.latitude}, ${$location.longitude}` : "").then(data => data).catch(err => err);

      if(storeInformation && storeInformation.error) {
        errorMessage = storeInformation.error
        storeInformation = "";
      }
      stores = storeInformation;
      isCurrentLocationAccessed = false
      setToStorage("HC_USER_LOCATION", JSON.stringify({ location: $location, isCurrentLocationAccessed}))
    }
    result = '';

    const sku = productSku;

    jQueryBopis('#hc-store-card').remove();
    if (event) eventTarget.prop("disabled", true);

    // checking if the number of stores is greater then 0 then creating a payload to check inventory
    if (storeInformation && storeInformation.response && storeInformation.response.numFound > 0) {

      let storeCodes = storeInformation.response.docs.filter(store => store["pickup_pref"] === "true").map((store) => {
        let storeCode = '';
        store.timings = getStoreTiming(store);

        // if storeCode starts with DC_ then removing the code
        if (store.storeCode.startsWith('DC_')) {
          storeCode = store.storeCode.substring(3);
        } else {
          storeCode = store.storeCode;
        }

        store.storeCode = storeCode;
        return storeCode;
      })

      // passing the facilityId as an array in the payload
      let payload = {"sku" : sku, "facilityIds": storeCodes};
      result = await checkInventory(payload)

      // mapping the inventory result with the locations to filter those stores whose inventory
      // is present and the store code is present in the locations.
      if (result.docs) {
        result = storeInformation.response.docs.filter((location) => {
          return result.docs.some((doc) => {
            return doc.facilityId === location.storeCode && doc.atp > 0;
          })
        })
      }
    }

    if (result.length > 0 && !result.includes('error')) {
      storesWithInventory = result;
      nearestStoreWithInventory = result[0];
    } else {
      nearestStoreWithInventory = ""
    }
    displayNearestStoreInformation(errorMessage);
    if (event) eventTarget.prop("disabled", false);
  }
  
  async function handleAddToCartEvent(event, location) {
    let eventTarget;
    if (event) {
      eventTarget = jQueryBopis(event.target);
      // to stop event bubbling when clicking on the Check Stores button
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    let storeInformation = {};
    let result = '';

    if(!location && jQueryBopis("#hc-bopis-store-pin").val() === queryString) {
      storeInformation = stores;
      result = storesWithInventory;
    } else {
      queryString = jQueryBopis("#hc-bopis-store-pin").val();
      setToStorage("HC_SEARCHED_CODE", queryString)
      storeInformation = await getStoreInformation(queryString).then(data => data).catch(err => err);

      if(storeInformation && storeInformation.error) {
        errorMessage = storeInformation.error
        storeInformation = "";
      }
      
      stores = storeInformation;
    }

    const sku = productSku;

    jQueryBopis('#hc-store-card').remove();
    if (event) eventTarget.prop("disabled", true);

    // checking if the number of stores is greater then 0 then creating a payload to check inventory
    if (storeInformation && storeInformation.response && storeInformation.response.numFound > 0) {

      let storeCodes = storeInformation.response.docs.filter(store => store["pickup_pref"] === "true").map((store) => {
        let storeCode = '';
        store.timings = getStoreTiming(store);

        // if storeCode starts with DC_ then removing the code
        if (store.storeCode.startsWith('DC_')) {
          storeCode = store.storeCode.substring(3);
        } else {
          storeCode = store.storeCode;
        }

        store.storeCode = storeCode;
        return storeCode;
      })

      // passing the facilityId as an array in the payload
      let payload = {"sku" : sku, "facilityIds": storeCodes};
      if(!result) {
        result = await checkInventory(payload)

        // mapping the inventory result with the locations to filter those stores whose inventory
        // is present and the store code is present in the locations.
        if (result.docs) {
          result = storeInformation.response.docs.filter((location) => {
            return result.docs.some((doc) => {
              return doc.facilityId === location.storeCode && doc.atp > 0;
            })
          })
          storesWithInventory = result;
        }
      }
    }

    displayStoreInformation(result)
    if (event) eventTarget.prop("disabled", false);
  }

  /*
  Function finds the name for day of the week

  @return {string} Day of the week
  */
  function getDay () {
    let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    let date = new Date();
    let dayName = days[date.getDay()];
    return dayName;
  }

  function getStoreTodayTiming(timing) {
    return timing[getDay()] ? timing[getDay()] : {};
  }

  function getConvertedTime (time) {
    if (time) {
      // Check correct time format and split into components
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) { // If time format correct
        time.pop(); // remove seconds from the time
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? 'am' : 'pm'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(''); // return adjusted time or original string
    }
    return '';
  }

  /*
  Function returns the open and close timing for a store for all week days

  @param {object} store An object containing store information
  @return {object} An object containing open and close timing for all week days
  */
  function getStoreTiming(store) {
    let days = {'monday': {}, 'tuesday': {}, 'wednesday': {}, 'thursday': {}, 'friday': {}, 'saturday': {}, 'sunday': {}};

    const storeTimingDays = Object.keys(store).filter((key) => key.includes('open') || key.includes('close'));

    return storeTimingDays.reduce((obj, key) => {
      const time = store[key];
      if (key.includes('open')) {
        obj[key.replace('_open', '')]['open'] = getConvertedTime(time)
      }
      if (key.includes('close')) {
        obj[key.replace('_close', '')]['close'] = getConvertedTime(time)
      }
      return obj;
    }, days)
  }

  function displayNearestStoreInformation(errorMessage) {
      jQueryBopis('.hc-no-store-found').empty();
      jQueryBopis('.hc-nearest-store-information').empty();

      const currentVariant = currentProduct.variants.find(variant => variant.id == variantId)

      if(nearestStoreWithInventory && nearestStoreWithInventory.storeName) {
        let $storeInformationCard = jQueryBopis(`
          <p>This product is available in store at 
            <span id="hc-nearest-store" class="hc-pointer hc-underline">${nearestStoreWithInventory.storeName}</span>
              in ${currentVariant.title.split("/").join(" ")}
          </p>
          <p id="hc-nearest-store">Showing availability near <span id="hc-searched-zip" class="hc-pointer hc-underline">${queryString}</span></p>
        `);
  
        closeStoreAvailabilityForm();
        jQueryBopis(".hc-store-availability-wrapper").show();
        jQueryBopis("#hc-store-availability").hide();
        jQueryBopis('.hc-nearest-store-information').append($storeInformationCard);
        jQueryBopis(".hc-nearest-store-information")[0].style.display = "block";
        jQueryBopis("#hc-searched-zip").on('click', openStoreAvailabilityForm);
        jQueryBopis("#hc-nearest-store").on('click', openBopisModal);
      } else {
        jQueryBopis(".hc-store-availability-wrapper").show();
        jQueryBopis("#hc-store-availability").hide();
        jQueryBopis('.hc-no-store-found').append(errorMessage ? errorMessage : 'No nearby stores available');
        jQueryBopis(".hc-no-store-found")[0].style.display = "block";
        jQueryBopis(".hc-nearest-store-information")[0].style.display = "none";
      }
  }

  // will check for the inventory for the product stock and if available then display the information on the UI
  function displayStoreInformation(result, errorMessage) {

    jQueryBopis('.hc-store-information').empty();
    // TODO Handle it in a better way
    // The content of error is not removed and appended to last error message
    jQueryBopis('.hc-store-not-found').remove();
    jQueryBopis('.hc-modal-content').append(jQueryBopis('<p class="hc-store-not-found"></p>'));
    const hcModalContent = jQueryBopis('.hc-modal-content')
  
    //check for result count, result count contains the number of stores count in result
    //TODO: find a better approach to handle the error secenario
    if (result.length > 0 && !result.includes('error')) {
      // Updating the PDP nearest store information when changing zipcode inside modal
      nearestStoreWithInventory = result[0];
      displayNearestStoreInformation();
      jQueryBopis('#hc-store-availability-pin').val(queryString);

      result.splice(10);

      result.map(async (store) => {
        let $storeCard = jQueryBopis('<div id="hc-store-card"></div>');
        const storeTodayTiming = getStoreTodayTiming(store.timings);
        let $storeInformationCard = jQueryBopis(`
        <div id="hc-store-details">
          <div id="hc-details-column">
            <p>
              <i class="fa fa-check hc-icon hc-list-icon" tabindex="0" style="color: green;"></i>
              <span>In stock</span>
            </p>
            <div>
              <p class="hc-store-title">${store.storeName ? store.storeName : ''}</p>
              <span class="hc-store-dist-metadata">${store.dist !== "Infinity" ? parseFloat((store.dist).toFixed(1)).toLocaleString() + ' mi. away from you' : ''}</span>
            </div>
            <p>
              <i class="fa fa-clock-o hc-icon hc-list-icon" tabindex="0"></i>
              <span>${ storeTodayTiming.open ? 'Open Today: <wbr>' + storeTodayTiming.open + ' - ': ''} ${storeTodayTiming.close ? storeTodayTiming.close : ''}</span>
            </p>
          </div>
          <div id="hc-details-column">
            <p>
              <i class="fa fa-envelope-o hc-icon hc-list-icon" tabindex="0"></i>
              <a ${store.storeEmail ? "href=mailto:"+store.storeEmail : ""}>${store.storeEmail ? store.storeEmail : '-'}</a>
            </p>
            <p>
              <i class="fa fa-phone hc-icon hc-list-icon" tabindex="0"></i>
              <a ${store.storePhone ? "href=tel:"+store.storePhone : ""}>${store.storePhone ? store.storePhone : '-'}</a>
            </p>
            <p>
              <i class="fa fa-map-marker hc-icon hc-list-icon" tabindex="0"></i>
              ${store.storeMapUrl ? "<a href="+store.storeMapUrl+" target='_blank'>" : "<span>"}
                ${store.address1 ? store.address1 : ''} <wbr>
                ${store.city ? store.city : ''}${store.stateCode ? `, ${store.stateCode}` : ''}${store.postalCode ? `, ${store.postalCode}` : ''}${store.countryCode ? `, ${store.countryCode}` : ''}
              ${store.storeMapUrl ? "</a>" : "</span>"}
            </p>
          </div>
        </div>`);

        let $lineBreak = jQueryBopis('<hr/>')

        $storeCard.append($storeInformationCard);
        $storeCard.append($lineBreak);

        jQueryBopis('.hc-store-information').append($storeCard);
      })

      //check whether the storeCard contains any children, if not then displaying error
      if (!jQueryBopis('.hc-store-information').children().length) {
        jQueryBopis('.hc-store-not-found').html('No stores found for this product');
        stores = [];
        storesWithInventory = [];
      }
    } else {
      jQueryBopis('.hc-store-not-found').append(errorMessage ? errorMessage : 'No stores found for this product');
      stores = [];
      storesWithInventory = [];
    }

    // hide all the h4 and p tags which are empty in the modal
    hcModalContent.find('h4:empty').hide();
  }

  document.addEventListener("product:variant-change", (event) => {
    variantId = event.detail.variant.id;
    initialiseBopis();
  });
})();